import { css, cx } from "@emotion/css";
import styled from "@emotion/styled";
import { Breakpoints, mq } from "src/helpers/mediaQuery";

interface EmptyBoxProps {
	title: string;
	className?: string;
	subtitle?: string;
}

const EmptyBox = ({ title, className, subtitle }: EmptyBoxProps) => {
	return (
		<div
			className={cx(
				className,
				"flex items-center justify-center flex-col text-center",
				css`
          min-height: 100px;
        `,
			)}
		>
			<h5 className="m-0 size-20 first-letter-upper">{title}</h5>
			<p
				className={cx(
					"mt-8 size-16-light text-grey",
					css`
            max-width: 350px;
          `,
				)}
			>
				{subtitle}
			</p>
		</div>
	);
};

export const EmptyTableBox = styled(EmptyBox)`
  min-height: unset;

  > svg {
    width: 25%;
  }

  > h5 {
    margin: 12px 0;
  }

  ${mq(Breakpoints.sm)} {
    > svg {
      width: 80%;
    }
  }
`;

export default EmptyBox;
